/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Posts_Cardtitle1Inputs */

const id_misc_posts_cardtitle1 = /** @type {(inputs: Misc_Posts_Cardtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jangan lewatkan kesempatan ini untuk memulai petualangan LEGO melintasi galaksi!`)
};

const ms_misc_posts_cardtitle1 = /** @type {(inputs: Misc_Posts_Cardtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jangan lepaskan peluang ini untuk memulakan perjalanan LEGO merentasi galaksi!`)
};

const da_misc_posts_cardtitle1 = /** @type {(inputs: Misc_Posts_Cardtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gå ikke glip af denne chance for at begive dig ud på en LEGO-infunderet rejse gennem galaksen!`)
};

const de_misc_posts_cardtitle1 = /** @type {(inputs: Misc_Posts_Cardtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verpassen Sie nicht diese Gelegenheit, sich auf eine LEGO-infundierte Reise durch die Galaxie zu begeben!`)
};

const en_us2_misc_posts_cardtitle1 = /** @type {(inputs: Misc_Posts_Cardtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Don't miss this chance to embark on a LEGO-infused journey across the galaxy!`)
};

const es_es2_misc_posts_cardtitle1 = /** @type {(inputs: Misc_Posts_Cardtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡No pierdas esta oportunidad de embarcarte en un viaje infused de LEGO por la galaxia!`)
};

const es_mx2_misc_posts_cardtitle1 = /** @type {(inputs: Misc_Posts_Cardtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡No pierdas esta oportunidad de embarcarte en un viaje infusionado de LEGO por la galaxia!`)
};

const fil_misc_posts_cardtitle1 = /** @type {(inputs: Misc_Posts_Cardtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huwag palampasin ang pagkakataong ito na magsimula sa isang paglalakbay na puno ng LEGO sa buong kalawakan!`)
};

const fr_misc_posts_cardtitle1 = /** @type {(inputs: Misc_Posts_Cardtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ne manquez pas cette chance de vous lancer dans un voyage LEGO à travers la galaxie !`)
};

const it_misc_posts_cardtitle1 = /** @type {(inputs: Misc_Posts_Cardtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non perdere questa occasione di imbarcarti in un viaggio LEGO attraverso la galassia!`)
};

const hu_misc_posts_cardtitle1 = /** @type {(inputs: Misc_Posts_Cardtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ne hagyd ki ezt a lehetőséget, hogy egy LEGO-val átitatott utazásra indulj a galaxisban!`)
};

const nl_misc_posts_cardtitle1 = /** @type {(inputs: Misc_Posts_Cardtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mis deze kans niet om aan een LEGO-doordrenkte reis door het sterrenstelsel te beginnen!`)
};

const no_misc_posts_cardtitle1 = /** @type {(inputs: Misc_Posts_Cardtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikke gå glipp av denne sjansen til å legge ut på en LEGO-infundert reise gjennom galaksen!`)
};

const pl_misc_posts_cardtitle1 = /** @type {(inputs: Misc_Posts_Cardtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie przegap tej okazji, aby wyruszyć w pełną LEGO podróż przez galaktykę!`)
};

const pt_br2_misc_posts_cardtitle1 = /** @type {(inputs: Misc_Posts_Cardtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não perca esta chance de embarcar em uma jornada repleta de LEGO pela galáxia!`)
};

const pt_misc_posts_cardtitle1 = /** @type {(inputs: Misc_Posts_Cardtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não perca esta oportunidade de embarcar numa viagem LEGO pela galáxia!`)
};

const ro_misc_posts_cardtitle1 = /** @type {(inputs: Misc_Posts_Cardtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nu rata această șansă de a porni într-o călătorie LEGO prin galaxie!`)
};

const fi_misc_posts_cardtitle1 = /** @type {(inputs: Misc_Posts_Cardtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Älä missaa tätä mahdollisuutta lähteä LEGO-matkalle galaksin halki!`)
};

const sv_misc_posts_cardtitle1 = /** @type {(inputs: Misc_Posts_Cardtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missa inte denna chans att ge dig ut på en LEGO-infuserad resa genom galaxen!`)
};

const vi_misc_posts_cardtitle1 = /** @type {(inputs: Misc_Posts_Cardtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đừng bỏ lỡ cơ hội bắt đầu một cuộc hành trình thấm đẫm LEGO qua thiên hà!`)
};

const tr_misc_posts_cardtitle1 = /** @type {(inputs: Misc_Posts_Cardtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Galakside LEGO temalı bir yolculuğa çıkmak için bu fırsatı kaçırmayın!`)
};

const cs_misc_posts_cardtitle1 = /** @type {(inputs: Misc_Posts_Cardtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nezmeškejte tuto šanci vydat se na LEGO-infused cestu galaxií!`)
};

const bg_misc_posts_cardtitle1 = /** @type {(inputs: Misc_Posts_Cardtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не пропускайте този шанс да се впуснете в LEGO-наситено пътешествие из галактиката!`)
};

const ru_misc_posts_cardtitle1 = /** @type {(inputs: Misc_Posts_Cardtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не упустите шанс отправиться в пропитанное LEGO путешествие по галактике!`)
};

const uk_misc_posts_cardtitle1 = /** @type {(inputs: Misc_Posts_Cardtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не пропустіть нагоду вирушити в LEGO-подорож галактикою!`)
};

const ar_misc_posts_cardtitle1 = /** @type {(inputs: Misc_Posts_Cardtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا تفوت هذه الفرصة لخوض رحلة مليئة بـ LEGO عبر المجرة!`)
};

const hi_misc_posts_cardtitle1 = /** @type {(inputs: Misc_Posts_Cardtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह अवसर न चूकें!`)
};

const th_misc_posts_cardtitle1 = /** @type {(inputs: Misc_Posts_Cardtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อย่าพลาดโอกาสในการเริ่มต้นการผจญภัยสไตล์ LEGO ข้ามกาแล็กซี!`)
};

const ja_misc_posts_cardtitle1 = /** @type {(inputs: Misc_Posts_Cardtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`銀河を巡る LEGO 満載の旅に出るこのチャンスをお見逃しなく！`)
};

const zh_cn2_misc_posts_cardtitle1 = /** @type {(inputs: Misc_Posts_Cardtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`千万不要错过这次踏上穿越银河系的乐高之旅的机会！`)
};

const zh_hant1_misc_posts_cardtitle1 = /** @type {(inputs: Misc_Posts_Cardtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`千萬不要錯過這次踏上穿越銀河系的樂高之旅的機會！`)
};

const ko_misc_posts_cardtitle1 = /** @type {(inputs: Misc_Posts_Cardtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGO로 가득한 은하계 여행을 떠날 이 기회를 놓치지 마세요!`)
};

/**
* | output |
* | --- |
* | "Don't miss this chance to embark on a LEGO-infused journey across the galaxy!" |
*
* @param {Misc_Posts_Cardtitle1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_posts_cardtitle1 = /** @type {((inputs?: Misc_Posts_Cardtitle1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Posts_Cardtitle1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_posts_cardtitle1(inputs)
	if (locale === "ms") return ms_misc_posts_cardtitle1(inputs)
	if (locale === "da") return da_misc_posts_cardtitle1(inputs)
	if (locale === "de") return de_misc_posts_cardtitle1(inputs)
	if (locale === "en-US") return en_us2_misc_posts_cardtitle1(inputs)
	if (locale === "es-ES") return es_es2_misc_posts_cardtitle1(inputs)
	if (locale === "es-MX") return es_mx2_misc_posts_cardtitle1(inputs)
	if (locale === "fil") return fil_misc_posts_cardtitle1(inputs)
	if (locale === "fr") return fr_misc_posts_cardtitle1(inputs)
	if (locale === "it") return it_misc_posts_cardtitle1(inputs)
	if (locale === "hu") return hu_misc_posts_cardtitle1(inputs)
	if (locale === "nl") return nl_misc_posts_cardtitle1(inputs)
	if (locale === "no") return no_misc_posts_cardtitle1(inputs)
	if (locale === "pl") return pl_misc_posts_cardtitle1(inputs)
	if (locale === "pt-BR") return pt_br2_misc_posts_cardtitle1(inputs)
	if (locale === "pt") return pt_misc_posts_cardtitle1(inputs)
	if (locale === "ro") return ro_misc_posts_cardtitle1(inputs)
	if (locale === "fi") return fi_misc_posts_cardtitle1(inputs)
	if (locale === "sv") return sv_misc_posts_cardtitle1(inputs)
	if (locale === "vi") return vi_misc_posts_cardtitle1(inputs)
	if (locale === "tr") return tr_misc_posts_cardtitle1(inputs)
	if (locale === "cs") return cs_misc_posts_cardtitle1(inputs)
	if (locale === "bg") return bg_misc_posts_cardtitle1(inputs)
	if (locale === "ru") return ru_misc_posts_cardtitle1(inputs)
	if (locale === "uk") return uk_misc_posts_cardtitle1(inputs)
	if (locale === "ar") return ar_misc_posts_cardtitle1(inputs)
	if (locale === "hi") return hi_misc_posts_cardtitle1(inputs)
	if (locale === "th") return th_misc_posts_cardtitle1(inputs)
	if (locale === "ja") return ja_misc_posts_cardtitle1(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_posts_cardtitle1(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_posts_cardtitle1(inputs)
	return ko_misc_posts_cardtitle1(inputs)
});
export { misc_posts_cardtitle1 as "misc.posts.cardTitle" }